import { createSelector } from 'reselect';
import { RootState } from '../../store';


const getActiveProductState = (state: RootState) => {

    return state.unitActiveProducts;
};

export const getActiveProduct = createSelector(
    getActiveProductState,
    unitActiveProducts => unitActiveProducts.activeProductData,
);

const getUnitId = (state: RootState, unitId: number) => unitId;

export const selectActiveProductByUnitId = createSelector(
    getActiveProduct,
    getUnitId,
    (unitActiveProducts, unitId) => unitActiveProducts.get(unitId),
);

export const selectActiveProductInCurrentTime = createSelector(
    getActiveProductState,
    unitActiveProducts => unitActiveProducts.activeProductInCurrentTime.filter(value => value.product),
);

export const selectLastUpdateProduct = createSelector(
    getActiveProductState,
    unitActiveProducts => unitActiveProducts.lastUpdateProduct,
);